export default class TranslationTest {
    static instance = null;

    constructor() {
        this.routes = {}; // {getPrompt,}
        this.prompts = {}; // seznam promptu dle modelu
        this.submitForm = this.submitForm.bind(this);
        this.analyze = this.analyze.bind(this);
        this.cleanResult = this.cleanResult.bind(this);
        this.changePrompt = this.changePrompt.bind(this);
        this.loadPromptFromServer = this.loadPromptFromServer.bind(this);
        this.savePrompts = this.savePrompts.bind(this);
        this.savePromptsFromForm = this.savePromptsFromForm.bind(this);
        this.clearPrompts = this.clearPrompts.bind(this);
        this.changeAnalyzeProject = this.changeAnalyzeProject.bind(this);

        $(document).on('submit', '#translationTestForm', this.submitForm);
        $(document).on('click', '#translationTestForm #js-analyze', this.analyze);
        $(document).on('click', '#js-clean', this.cleanResult);
        $(document).on('click', '#js-clear-models', this.clearPrompts);
        $(document).on('change', 'select[name="translator"]', this.changePrompt);
        $(document).on('change', 'select[name="analyze_project_id"]', this.changeAnalyzeProject);
        $(document).on('blur', '#translationTestForm textarea[name="system_prompt"]', this.savePromptsFromForm);
    }

    changeAnalyzeProject(e) {
        let target = $(e.target);
        let selected = target.find('option:selected');
        let user_id = selected.val();
        $.ajax( {
            type: 'get',
            dataType: 'json',
            url: this.routes['getAnalyzeProject'],
            data: {user_id: user_id},
            success: (result) => {
                if (result.error) {
                    alert(result.error);
                } else {
                    $('textarea[name="style_json"]').val(result.setting['ai-identify-client-text']);
                    $('textarea[name="urls"]').val(result.setting['ai-identify-client-urls'].join("\n"));

                    console.log(result);
                }
            },
            error: (err) => {
                console.log(err);
            }
        })
    }

    savePromptsFromForm(e) {
        let target = $(e.target);
        let model = $('#translationTestForm select[name="translator"]').val();
        this.prompts[model].first = target.val();
        this.savePrompts();
    }

    changePrompt(e) {
        let target = $(e.target);
        let selected = target.find('option:selected');
        let model = selected.val();

        if (!(model in this.prompts)) {
            this.loadPromptFromServer(model);
        } else {
            this.setPromptsToForm(model);
        }
    }

    setPromptsToForm(model) {
        $('#translationTestForm textarea[name="system_prompt"]').val(this.prompts[model].first);
    }

    loadPromptFromServer(model) {
        $.ajax({
            type: 'get',
            dataType: 'json',
            url: this.routes['getPrompt'],
            data: {model: model},
            success: (result) => {
                this.prompts[model] = result.prompts;
                this.savePrompts();
                this.setPromptsToForm(model);
            },
            error: (err) => {
                console.log(err);
            }
        })
    }

    savePrompts() {
        // save this.prompts to browser local storage
        localStorage.setItem('prompts', JSON.stringify(this.prompts));
    }

    loadPrompts() {
        // load this.prompts from browser local storage
        let prompts = localStorage.getItem('prompts');
        if (prompts) {
            this.prompts = JSON.parse(prompts);
        } else {
            this.prompts = {};
        }
    }

    clearPrompts() {
        // clear this.prompts from browser local storage
        localStorage.removeItem('prompts');
        this.prompts = {};
        $('select[name="translator"]').trigger('change');
    }


    analyze(e) {
        e.preventDefault();
        let targetBtn = $(e.target);
        let url = $(e.target).data('route');
        let data = $('#translationTestForm [name="urls"]').val();

        let lastText = targetBtn.text();
        targetBtn.attr('disabled', 'disabled').text('Analyzing...');

        $.ajax({
            type: 'post',
            url: url,
            data: {urls: data},
            success: (result) => {
                if (result.error) {
                    alert(result.error);
                } else {
                    $('#translationTestForm [name="style_json"]').val(result.text);
                }
            },
            error: (err) => {
                console.log(err);
            },
            complete: () => {
                targetBtn.removeAttr('disabled').text(lastText);
            }
        })
    }


    submitForm(e) {
        e.preventDefault();
        let targetBtn = $(e.target).find('button[type="submit"]');
        let url = $(e.target).attr('action');
        let data = $(e.target).serialize();
        let lastText = targetBtn.text();
        targetBtn.attr('disabled', 'disabled').text('Sending...');

        $.ajax({
            type: 'post',
            url: url,
            data: data,
            success: (result) => {
                if (result.error) {
                    alert(result.error);
                } else {
                    // merge the result with the original text
                    let originalText = $('#js-translation-result').html();
                    $('#js-translation-result').html(originalText + result.text + '<br><hr/><br>');
                    $('#js-translation-prompt').html(result.prompt);
                }
            },
            error: (err) => {
                console.log(err);
            },
            complete: () => {
                targetBtn.removeAttr('disabled').text(lastText);
            }
        })
    }

    cleanResult(e) {
        e.preventDefault();
        $('#js-translation-result').html('');
    }

    static init(initData) {
        if (!this.instance) {
            this.instance = new TranslationTest();
            if (initData) {
                for (let key in initData) {
                    if (initData.hasOwnProperty(key)) {
                        this.instance[key] = initData[key];
                    }
                }
            }
            this.instance.loadPrompts();
            $('select[name="translator"]').trigger('change');
        }
    }


}
